<template>
    <div class="trade-detail">
        <div class="type-box">
            <div class="title-line"></div>
            <span class="title-content">{{ type }}</span>
        </div>
        <el-table
            :data="list.slice((curPage - 1) * pagecount, curPage * pagecount)"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
        >
            <el-table-column label="产品名称" width="320" class-name="fund-offset">
                <template slot-scope="scope">
                    <div style="color: #333333">
                        {{ scope.row.fundname }}
                    </div>
                    <div style="color: #666666">({{ scope.row.fundcode }})</div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="销售机构" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.distributorname }}</span>
                </template>
            </el-table-column> -->
            <el-table-column label="交易类型" align="center">
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.busitype ? $cache.getDict("110336", scope.row.busitype) : "" }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="金额/份额" align="center">
                <template slot-scope="scope">
                    <span v-if="checkIsShareType(scope.row.busitype)">
                        {{ scope.row.currentshare ? scope.row.currentshare + "份" : "--" }}
                    </span>
                    <span v-else>
                        {{ $util.fmtNum(scope.row.applicationamount) }}
                        <span
                            v-if="
                                (scope.row.applicationamount ||
                                    scope.row.applicationamount === 0) &&
                                !isNaN(scope.row.applicationamount)
                            "
                        >
                            元
                        </span>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="交易日期" align="center">
                <template slot-scope="scope">
                    <span style="color: #333333">
                        {{ $util.fmtDate(scope.row.transactiondate) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" plain size="small" v-on:click.stop="dealWarn(scope.row)">
                        阅读风险警示
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="list.length > pagecount">
            <el-pagination
                :page-size="pagecount"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="list.length"
                v-on:current-change="newData"
            />
        </el-row>
        <risk-dialog :fund="selectItem" v-on:event-fn="ensure" />
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import riskDialog from "@/components/misc/riskDialog";

export default {
    name: "WarnType",
    components: { riskDialog },
    mixins: [mixin],
    props: {
        type: {
            type: String,
            default: ""
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectItem: {}, // 选中项
            pagecount: 5, // 分页条数
            curPage: 1 // 当前页
        };
    },
    methods: {
        checkIsShareType(busitype) {
            if (!busitype) return false;
            // 110336 交易类型字典
            const label = this.$cache.getDict("110336", busitype) || "";
            return label.indexOf("持有份额") > -1;
        },
        // 获取新一页数据
        newData(val) {
            this.pageoffset = val;
        },
        // 阅读风险警示
        dealWarn(val) {
            this.selectItem = Object.assign({}, val, { way: "P4" });
        },
        // 确认操作
        ensure(val) {
            this.$emit("dealWarn", val);
        }
    }
};
</script>

<style lang="scss" scoped>
.type-box {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 1px solid #f1f1f1;
}
.table {
    margin-top: 20px;
}
.fund-name {
    color: #333333;
    font-size: 14px;
    cursor: pointer;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}

.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: var(--color-primary);
}
.el-button--text.is-disabled {
    color: #cccccc;
}
.el-table {
    border: 1px solid #f1f1f1;
}
.el-table--fit {
    margin-bottom: 15px;
}
.el-pagination {
    margin-bottom: 20px;
}
.dialog-footer {
    display: flex;
    gap: 20px;
    justify-content: center;
    text-align: center;
    margin-top: 24px;
}

.footer-button {
    width: 180px;
    height: 42px;
    border-radius: 2px;
}
.cancel {
    color: #666666;
    background: #e4e4e4;
    border-color: transparent;
}
</style>
